// 可以进行异步操作，如果需要改变states，则必须通过commit调用mutations
import {formatDate} from './../../utils/date'
import {removeToken, removeUserId} from '../../utils/authc'
import {fmtMoney} from '../../utils/public'
import * as TYPES from './mutation-types'
import qs from 'qs'
import hexsha1 from './../../../static/js/hex-sha1'

export default {
  // 加密密码
  encryptPassword ({commit}, psd) {
    return hexsha1.hex_sha1(psd)
  },

  // login登录
  async login ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('LOGIN_URL'), qs.stringify(payload))
    if (result.result === '1') {
      // 登录成功，更新用户信息
      commit(TYPES.ADD_USER_LOGIN_INFO, result.data)
      return {
        data: result.data,
        result: '1'
      }
    } else {
      return {
        result: '0',
        data: result.data
      }
    }
  },

  // 退出登录
  logout ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    Vue.$http.get(Vue.getData('LOGOUT_URL')).then(res => {
      if (res.result === '1') {
        removeToken()
        removeUserId()
        window.location.reload()
        Vue.$router.push({name: 'Login'})
      }
    })
  },

  // 获取当前用户信息
  getCurrentUserInfo ({commit}, Vue) {
    Vue.$http.get(Vue.getData('GET_USER_BASE_INFO')).then(res => {
      if (res.result === '1') {
        let data = res.data
        if (data.LAST_LOGIN_DT !== undefined) {
          data.LAST_LOGIN_DT = formatDate(new Date(data.LAST_LOGIN_DT.time), 'yyyy-MM-dd hh:mm:ss')
        }
        if (data.CREATE_DT !== undefined) {
          data.CREATE_DT = formatDate(new Date(data.CREATE_DT.time), 'yyyy-MM-dd hh:mm:ss')
        }
        commit(TYPES.ADD_CURRENT_USER, data)
      }
    })
  },

  // 格式化时间
  formatDate ({commit}, payload) {
    let date = payload.date
    let dft = payload.dft
    return formatDate(date, dft)
  },

  // 格式化金额
  fmtMoney ({commit}, payload) {
    return fmtMoney(payload)
  },

  // 获取全部权限，添加到state中
  async getAllPermission ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.get(Vue.getData('GET_ALL_PERMISSION_URL'))
    if (result.result === '1') {
      commit(TYPES.ADD_ALL_PERMISSION_LIST, result.data)
    }
  },

  // 获取菜单资源详情
  async getMenuInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_MENU_INFO_URL'), qs.stringify(payload))
  },

  // 保存菜单资源详情
  async updateMenuInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('UPDATE_MENU_INFO_URL'), qs.stringify(payload))
  },

  // 删除菜单资源
  async delMenuInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('DEL_MENU_URL'), qs.stringify(payload))
  },

  // 新增菜单资源
  async addMenu ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('ADD_MENU_URL'), qs.stringify(payload))
  },

  // 获取角色列表
  async getRoleList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_ROLE_LIST_URL'), qs.stringify(payload))
  },

  // 获取角色和权限详情信息
  async getRoleAndPermissionInfo ({commint}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_ROLE_PERMISSION_DETAIL_URL'), qs.stringify(payload))
  },

  // 添加或修改角色信息
  async editOrCreateRole ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('EDIT_OR_CREATE_ROLE_URL'), qs.stringify(payload))
  },

  // 删除角色信息
  async delRoleInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('DEL_ROLE_INFO_URL'), qs.stringify(payload))
  },

  // 获取用户管理列表
  async getUserManagementList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('USER_MANAGEMENT_LIST_URL'), qs.stringify(payload))
  },

  // 获取用户基本信息
  getUserBaseInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    Vue.$http.post(Vue.getData('GET_USER_BASE_INFO'), qs.stringify(payload)).then(res => {
      if (res.result === '1') {
        let data = res.data
        if (data.LAST_LOGIN_DT !== undefined) {
          data.LAST_LOGIN_DT = formatDate(new Date(data.LAST_LOGIN_DT.time), 'yyyy-MM-dd hh:mm:ss')
        }
        if (data.CREATE_DT !== undefined) {
          data.CREATE_DT = formatDate(new Date(data.CREATE_DT.time), 'yyyy-MM-dd hh:mm:ss')
        }
        commit(TYPES.ADD_USER_BASE_INFO, data)
      }
    })
  },

  // 模糊查询业务员列表
  async fuzzyQuerySaleList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('FUZZY_QUERY_SALE_LIST_URL'), qs.stringify(payload))
  },

  // 获取公司名称和ID列表
  getCompanyNameIdList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    Vue.$http.get(Vue.getData('GET_COMPANY_NAME_ID_LIST')).then(res => {
      if (res.result === '1') {
        commit(TYPES.ADD_COMPANY_NAME_ID_LIST, res.data)
      }
    })
  },

  // 获取医院名称和ID列表
  getHospitalNameIdList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    Vue.$http.get(Vue.getData('GET_HOSPITAL_NAME_ID_LIST')).then(res => {
      if (res.result === '1') {
        commit(TYPES.ADD_HOSPITAL_NAME_ID_LIST, res.data)
      }
    })
  },
  // 获取医院名称和ID列表
  async getHospitalNameIdListFromPms ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_HOSPITAL_NAME_ID_LIST_FROM_PMS'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },

  // 清空用户基本信息
  clearUserBaseInfo ({commit}, payload) {
    commit(TYPES.CLEAR_USER_BASE_INFO)
  },

  // 修改用户基本信息
  async editUserBaseInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('EDIT_USER_BASE_INFO_URL'), qs.stringify(payload))
  },

  // 判断用户名是否已经存在
  async isExistUserNameOrPhone ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let res = await Vue.$http.post(Vue.getData('IS_EXIST_USERNAME_OR_PHONE_URL'), qs.stringify(payload))
    if (res.result === '1') {
      return res.data
    }
  },

  // 修改管理员注册当前的执行步骤
  editRegisterStep ({commit}, payload) {
    commit(TYPES.EDIT_ADMIN_REGISTER_STEP, payload)
  },

  // 部分注册信息提交到vuex
  submitRegisterUserInfo ({commit}, payload) {
    commit(TYPES.ADD_ADMIN_REGISTER_USER_INFO, payload)
  },

  // 管理员提交注册信息
  async adminSubmitRegisterInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('ADMIN_REGISTER_USER_URL'), qs.stringify(payload))
  },

  /* ************************************ 订单管理 start ****************************** */

  // 获取订单列表
  async getOrderList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_OERDER_LIST'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },

  // 删除订单
  async deleteOrder ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('DELETE_ORDER_URL'), qs.stringify(payload))
  },

  // 获取订单详情
  async getOrderDetail ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_ORDER_DETAIL_URL'), qs.stringify(payload))
    if (result.result === '1') {
      commit(TYPES.ADD_ORDER_DETAIL_DATAS, result.data)
      return {
        result: '1'
      }
    }
  },

  // 获取订单数据详情
  async getOrderDetailInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_ORDER_DETAIL_INFO_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },

  // 修改订单信息
  async editOrder ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('EDIT_ORDER_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1'
      }
    }
  },

  // 查询订单最终报告信息
  async getOrderFinalReport ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_ORDER_DETAIL_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },

  // 审核通过最终报告
  async passOrderFinalReportAudit ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('PASS_ORDER_FINAL_REPORT_AUDIT_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 审核通过最终报告
  async passOrderEpsReportAudit ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('PASS_ORDER_EPS_REPORT_AUDIT_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
    return result
  },
  // 审核不通过最终报告
  async refuseOrderFinalReportAudit ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('REFUSE_ORDER_FINAL_REPORT_AUDIT_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 审核eps不通过最终报告
  async refuseEpsFinalReportAudit ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('REFUSE_EPS_FINAL_REPORT_AUDIT_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 诊断报告上传成功后修改订单状态和更新报告链接
  async updateOrderAndEpsOrderAndSnStatus ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('UPDATE_ORDER_AND_EPS_ORDER_AND_SN_STATUS'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
    return result
  },
  // 转移订单
  async orderTransfer ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('ORDER_TRANSFER'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  /* ************************************ 订单管理 end ****************************** */
  /* ************************************ 积分管理 start ****************************** */

  // 获取积分列表
  async getPointList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_POINT_LIST'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  /* ************************************ 积分管理 end ****************************** */
  /* ************************************ 新闻管理 start ****************************** */

  // 获取新闻列表
  async getNewsList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_NEW_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 保存新闻
  async saveNews ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('SAVE_NEWS_INFO_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1'
      }
    }
  },
  // 根据新闻id删除新闻新
  async deleteNews ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('DELETE_NEWS_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1'
      }
    }
  },
  // 根据新闻id修改新闻信息
  async updateNews ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('UPDATE_NEWS_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1'
      }
    }
  },
  // 根据新闻id获取新闻信息
  async getNewsInfoByNewId ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_NEWS_INFO_BY_NEW_ID_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  /* ************************************ 新闻管理 end ****************************** */
  /* ************************************ 会议管理 start ****************************** */
  // 新增会议
  async saveMeeting ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('SAVE_MEETING_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1'
      }
    }
  },
  // 删除会议信息
  async deleteMeeting ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('DELETE_MEETING_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1'
      }
    }
  },
  // 修改会议信息
  async updateMeeting ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('UPDATE_MEETING_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1'
      }
    }
  },
  // 根据会议id获取会议详情
  async getMeetingInfoByMeetingId ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_MEETING_INFO_BY_MEETING_ID_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取会议列表
  async getMeetingList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_MEETING_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  /* ************************************ 会议管理 end ****************************** */
  /* ************************************ 疑难分享 start ****************************** */
  // 添加疑难分享
  async saveSharing ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('SAVE_SHARING_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1'
      }
    }
  },
  // 删除分享信息
  async deleteSharing ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('DELETE_SHARING_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1'
      }
    }
  },
  // 修改分享信息
  async updateSharing ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('UPDATE_SHARING_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1'
      }
    }
  },
  // 根据分享ID获取分享信息
  async getSharingInfoBySharingId ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_SHARING_INFO_BY_SHARINGID_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取疑难分享列表
  async getSharingList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_SHARING_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  /* ************************************ 疑难分享 end ****************************** */

  /* ************************************ 人员管理 start ****************************** */
  // 获取病人列表
  async getPatientList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_PATIENT_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取病人基本信息
  async getPatientInfoDetail ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_PATIENT_INFO_DETAIL_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 查询已绑定的打印员信息
  async getExistsPatientPrinterList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_EXISTS_PATIENT_PRINTER_LIST'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 保存病人基本信息
  async savePatientInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('SAVE_PATIENT_INFO_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 删除患者记录
  async delPatient ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('DEL_PATIENT_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取病人账单详情
  async getPatientOrderDetail ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_PATIENT_ORDER_DETAIL_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取门诊医生列表
  async getOutDoctorList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_OUT_DOCTOR_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取门诊医生基本信息
  async getOutDoctorInfoDetail ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_OUT_DOCTOR_INFO_DETAIL_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 保存门诊医生基本信息
  async saveOutDoctorInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('SAVE_OUT_DOCTOR_INFO_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 修改门诊医生状态
  async updateOutDoctorStatus ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('UPDATE_OUT_DOCTOR_STATUS_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 删除门诊医生记录
  async delOutDoctor ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('DEL_OUT_DOCTOR_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取门诊医生医院信息
  async getOutDoctorHospitalDetail ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_OUT_DOCTOR_HOSPITAL_DETAIL_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    } else {
      return {
        result: '0'
      }
    }
  },
  // 获取门诊医生订单信息
  async getOutDoctorOrderDetail ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_OUT_DOCTOR_ORDER_DETAIL_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取诊断专家列表
  async getExpertList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_EXPERT_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取诊断专家信息
  async getExpertInfoDetail ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_EXPERT_INFO_DETAIL_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 保存诊断专家信息
  async saveExpertInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('SAVE_EXPERT_INFO_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 删除诊断专家记录
  async delExpert ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('DEL_EXPERT_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取诊断专家图文信息
  async getExpertPicDetail ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_EXPERT_PIC_DETAIL_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 上传诊断专家图文
  async uploadExpertPic ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('UPLOAD_EXPERT_PIC_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取诊断专家医院信息
  async getExpertHospitalDetail ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_EXPERT_HOSPITAL_DETAIL_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取诊断专家订单信息
  async getExpertOrderDetail ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_EXPERT_ORDER_DETAIL_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取销售人员列表信息
  async getSaleList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_SALE_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取销售人员信息
  async getSaleInfoDetail ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_SALE_INFO_DETAIL_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 保存销售人员信息
  async saveSaleInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('SAVE_SALE_INFO_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 删除销售人员记录
  async delSale ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('DEL_SALE_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取销售人员公司信息
  async getSaleCompanyDetail ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_SALE_COMPANY_DETAIL_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取销售人员直属门诊医生记录
  async getSaleDoctorDetail ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_SALE_DOCTOR_DETAIL_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取销售人员附属销售人员记录
  async getSaleSubsidiarySaleDetail ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_SALE_SUBSIDIARY_SALE_DETAIL_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取医院列表
  async getHospitalList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_HOSPITAL_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取公司列表
  async getCompanyList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_COMPANY_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取门诊医生信息
  async getOutDoctorInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_OUT_DOCTOR_INFO_URL'), qs.stringify(payload))
  },

  // 获取业务员基本信息
  async getSaleBaseInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_SALE_BASE_INFO_URL'), qs.stringify(payload))
  },
  // 获取打印员基本信息
  async getPrinterList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_PRINTER_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 修改打印员绑定状态
  async changePrinterStatus ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_PRINTER_DETAIL_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  /* ************************************ 人员管理 end ******************************** */
  /* ************************************ 同步数据 start ****************************** */
  // 获取pms系统中的诊断专家信息
  async getPmsExpert ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_PMS_EXPERT_URL'), qs.stringify(payload))
  },
  // 同步pms系统中的诊断专家信息
  async synchroExpert ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('SYNCHRO_EXPERT_URL'), qs.stringify(payload))
  },
  // 获取pms系统中的医院信息
  async getPmsHospital ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_PMS_HOSPITAL_URL'), qs.stringify(payload))
  },
  // 同步pms系统中的医院信息
  async synchroHospital ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('SYNCHRO_HOSPITAL_URL'), qs.stringify(payload))
  },
  // 其他
  // 刷新专家列表
  async reExpert ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.get(Vue.getData('SYNC_REFRESH_EXPERT_URL'))
  },

  /* ************************************ 同步数据 end ******************************** */

  /* ********************************* 分成管理 action start ***************************** */
  // 获取分成规则列表
  async getShareRuleList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('SHARE_RULE_LIST_URL'), qs.stringify(payload))
  },

  // 更新分成规则
  async updateShareRule ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('UPDATE_SHARE_RULE_URL'), qs.stringify(payload))
  },

  // 获取提现申请列表
  async getCashWithdrawList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('CASH_WITHDRAW_LIST_URL'), qs.stringify(payload))
  },

  // 设置正在审核的提现ID
  setAuditWithdrawId ({commit}, payload) {
    commit(TYPES.ADD_AUDIT_WITHDRAW_ID, payload)
  },

  // 根据提现ID获取详情
  async getWithdrawDetail ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_CASE_WITHDRAW_DETAIL_URL'), qs.stringify(payload))
  },

  // 获取资金明细
  async getFundsDetailList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_FUNDS_DETAIL_LIST_URL'), qs.stringify(payload))
  },

  // 通过提现申请
  async passCashWithdraw ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('PASS_CASH_WITHDRAW_URL'), qs.stringify(payload))
  },

  // 拒绝提现申请
  async refuseCashWithdraw ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('REFUSE_CASH_WITHDRAW_URL'), qs.stringify(payload))
  },

  // 完成转账
  async completeTransfer ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('COMPLETE_TRANSFER_URL'), qs.stringify(payload))
  },

  /* ********************************* 分成管理 action end ***************************** */

  /* ********************************* 机构管理 action start ***************************** */
  // 新增医院
  async saveHospitalInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('SAVE_HOSPITAL_INFO_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1'
      }
    }
  },
  // 获取医院列表
  async getAllHospitalList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_ALL_HOSPITAL_LIST'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 删除医院信息
  async delHospitalInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('DEL_HOSPITAL_INFO_URL'), qs.stringify(payload))
  },
  // 修改医院基本信息
  async editHospitalBaseInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('EDIT_HOSPITAL_BASE_INFO_URL'), qs.stringify(payload))
  },
  // 获取医院的基本信息
  async getHospitalBaseInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_HOSPITAL_BASE_INFO'), qs.stringify(payload))
    if (result.result === '1') {
      if (result.data.CREATE_DATE !== undefined) {
        result.data.CREATE_DATE = formatDate(new Date(result.data.CREATE_DATE.time), 'yyyy-MM-dd hh:mm:ss')
      }
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 判断医院是否已经存在
  async isExistHospitalName ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let res = await Vue.$http.post(Vue.getData('IS_EXIST_HOSPITAL_NAME_URL'), qs.stringify(payload))
    if (res.result === '1') {
      return res.data
    }
  },

  // 获取公司列表
  async getAllCompanyList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_ALL_COMPANY_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 添加公司
  async saveCompanyInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('SAVE_COMPANY_INFO_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1'
      }
    }
  },
  // 删除公司信息
  async delCompanyInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('DEL_COMPANY_INFO_URL'), qs.stringify(payload))
  },
  // 修改公司基本信息
  async editCompanyBaseInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('EDIT_COMPANY_BASE_INFO_URL'), qs.stringify(payload))
  },
  // 根据公司Id 查询公司详情
  async getCompanyBaseInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_COMPANY_BASE_INFO_URL'), qs.stringify(payload))
    if (result.result === '1') {
      if (result.data.CREATE_DATE !== undefined) {
        result.data.CREATE_DATE = formatDate(new Date(result.data.CREATE_DATE.time), 'yyyy-MM-dd hh:mm:ss')
      }
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 判断医院是否已经存在
  async isExistCompanyName ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let res = await Vue.$http.post(Vue.getData('IS_EXIST_COMPANY_NAME_URL'), qs.stringify(payload))
    if (res.result === '1') {
      return res.data
    }
  },

  // 获取实验室站点列表
  async getLaboratoryList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_LABORATORY_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },

  // 新增实验室站点
  async saveLaboratoryInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('SAVE_LABORATORY_INFO_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1'
      }
    }
  },

  // 根据实验室站点id，获取实验室信息
  async getLaboratoryInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_LABORATORY_INFO_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },

  // 判断实验室是否已经存在
  async isExistLaboratoryName ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let res = await Vue.$http.post(Vue.getData('IS_EXIST_LABORATORY_NAME_URL'), qs.stringify(payload))
    if (res.result === '1') {
      return res.data
    }
  },

  // 修改实验室信息
  async updateLaboratoryInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let res = await Vue.$http.post(Vue.getData('UPDATE_LABORATORY_INFO_URL'), qs.stringify(payload))
    if (res.result === '1') {
      return {
        result: '1'
      }
    }
  },

  // 删除实验室信息
  async deleteLaboratoryInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let res = await Vue.$http.post(Vue.getData('DELETE_LABORATORY_INFO_URL'), qs.stringify(payload))
    if (res.result === '1') {
      return {
        result: '1'
      }
    }
  },
  /* ********************************* 机构管理 action end ***************************** */

  /* ********************************* 食道筛查 action start ***************************** */
  /**
   * 获取食道筛订单列表
   * @author JKD
   * @data 2019/2/13 15:09
   */
  async getEsophagusOrderList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_ESOPHAGUS_ORDER_LIST'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },

  // 根据食道筛订单Id 查询食道筛订单详情
  async getEsophagusOrderDetailInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_ESOPHAGUS_ORDER_DETAIL_INFO_URL'), qs.stringify(payload))
    if (result.result === '1') {
      /* if (result.data.CREATE_DATE !== undefined) {
        result.data.CREATE_DATE = formatDate(new Date(result.data.CREATE_DATE.time), 'yyyy-MM-dd hh:mm:ss')
      } */
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 修改食道筛订单信息
  async editEsophagusOrder ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('EDIT_ESOPHAGUS_ORDER_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1'
      }
    }
  },
  // 根据食订单Id 查询食道筛产品序列号
  async getEsophagusSequenceList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_ESOPHAGUS_SEQUENCE_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },

  // 数据修复仅限用于购买后没有进行取货或者取货后绑定失败的情况下进行操作
  async dataRecovery ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_DATA_RECOVERY_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },

  // 查询产品的一生
  async getProductByCheckId ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post('products/getProductByCheckId', qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },

  async getCaseByDoctorId ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post('synchro/getCaseByDoctorId', qs.stringify(payload))
    return result
  },

  // 根据食订单Id 进行退款
  async getRefund ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_REFUND'), qs.stringify(payload))
    return result
  },

  // 获取待配货订单列表
  async getEsophagusPendingOrderList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_ESOPHAGUS_PENDING_ORDER_LIST_URL'), qs.stringify(payload))
    if ((result.result === '1')) {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取已打印的二维码列表 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  async getQRCodeList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_QR_CODE_LIST_URL'), qs.stringify(payload))
    if ((result.result === '1')) {
      return {
        result: '1',
        data: result.data
      }
    }
  },

  // 添加二维码信息
  async addQRCodeNumber ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('ADD_QR_CODE_NUMBER'), qs.stringify(payload))
    if ((result.result === '1')) {
      return {
        result: '1'
      }
    } else {
      return {
        result: '0'
      }
    }
  },
  // 根据二维码的信息
  async delQRCode ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('DELETE_QRCODE_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1'
      }
    }
  },
  // 添加产品序列号
  async addSerialNumber ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('ADD_SERIAL_NUMBER_URL'), qs.stringify(payload))
    if ((result.result === '1')) {
      return {
        result: '1'
      }
    } else {
      return {
        result: '0'
      }
    }
  },
  // 添加产品序列号
  async getproductCode ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_PRODUCT_CODE'), qs.stringify(payload))
    if ((result.result === '1')) {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 添加二维码信息（二维码管理平台）
  async getQRCode ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('CREATE_QR_CODE'), qs.stringify(payload))
    if ((result.result === '1')) {
      return {
        result: '1',
        data: result.data
      }
    }
  },

  // 获取待出库食道筛订单列表
  async getOutboundOrderList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_OUTBOUND_ORDER_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },

  // 实现出库操作
  async outboundOperation ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('OUTBOUND_OPERATION_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    } else {
      return {
        result: '0',
        data: result.data
      }
    }
  },

  /**
   *  获取待入库产品列表
   * @author JKD
   * @data 2019/2/19 13:47
   */
  async getProductStorageList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_PRODUCT_STORAGE_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },

  /**
   *  获取顺丰路由信息
   * @author JKD
   * @data 2019/2/19 13:47
   */
  async getEpsSfRountList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GETEPSSFROUNTLIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },

  /**
   *  取消顺丰订单
   * @author JKD
   * @data 2019/2/19 13:47
   */
  async cancelSfOrder ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('CANCELSFORDER_URL'), qs.stringify(payload))
    return result
  },

  /**
   * 实现入库操作
   * @author JKD
   * @data 2019/2/19 15:36
   */
  async epsSnInStorage ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('EPS_SN_IN_STORAGE_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1'
      }
    } else {
      return {
        result: '0'
      }
    }
  },
  /**
   *  获取产品列表
   * @author JKD
   * @data 2019/2/20 11:26
   */
  async getProductList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_PRODUCT_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取公司名称和ID列表
  getLaboratoryIdNameIdList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    Vue.$http.get(Vue.getData('GET_LAB_NAME_ID_LIST_URL')).then(res => {
      if (res.result === '1') {
        commit(TYPES.ADD_LAB_NAME_ID_LIST, res.data)
      }
    })
  },
  // 根据产品ID获取产品详情
  async getEpsSnDetail ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_EPS_SN_DETAIL_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 修改产品信息
  async editEpsSn ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('EDIT_EPS_SN_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1'
      }
    }
  },
  // 获取待寄回产品列表
  async getAwaitBackProductList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_AWAIT_BACK_PRODUCT_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取实验室信息
  async getLabInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_LAB_INFO_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 产品添加寄回站点
  async editEpsLab ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('EDIT_EPS_LAB_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1'
      }
    } else {
      return {
        result: '0'
      }
    }
  },
  // 添加患者信息和订单信息
  async saveEsophagusOrder ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('SAVE_ESOPHAGUS_ORDER'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1'
      }
    } else {
      return {
        result: '0'
      }
    }
  },
  // 添加病例推送订单信息
  async savePushOrderInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('SAVE_PUSH_ORDERINFO'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1'
      }
    } else {
      return {
        result: '0'
      }
    }
  },
  // 从pms系统中获取病例列表
  async getCaseListFromPms ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_CASE_LIST_FROM_PMS'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    } else {
      return {
        result: '0'
      }
    }
  },
  async migrateImages ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post('/api/cases/migrateImages', qs.stringify(payload))
    return result
  },
  // 从pms系统中获取查询未推送病例
  async getNoPushCaseListFromPms ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post('synchro/getNoPushCaseListFromPms', qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    } else {
      return {
        result: '0'
      }
    }
  },
  // 根据订单id获取食康列表
  async getEpsSnListByOrderId ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_EPS_SN_LIST_BY_ORDER_ID'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    } else {
      return {
        result: '0'
      }
    }
  },
  // 订单将
  async bindCaseOrderId ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('BIND_CASE_ORDER_ID'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 审核并推送报告
  async pushCaseEpsReport ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('PUSH_CASE_EPS_REPORT'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
    return result
  },
  /* ********************************* 食道筛查 action end ***************************** */

  /* ********************************* 字典表 action start ***************************** */

  // 用户状态列表
  getUserStatusDicList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    Vue.$http.get(Vue.getData('GET_USER_STATUS_DIC_LIST')).then(res => {
      if (res.result === '1') {
        commit(TYPES.ADD_USER_STATUS_DIC_LIST, res.data)
      }
    })
  },

  // 系统角色列表
  getSysRoleList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    Vue.$http.get(Vue.getData('GET_ALL_SYS_ROLE_LIST')).then(res => {
      if (res.result === '1') {
        commit(TYPES.ADD_SYS_ROLE_LIST, res.data)
      }
    })
  },

  // 医院等级列表
  getHospitalDegreeList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    Vue.$http.get(Vue.getData('GET_HOSPITAL_DEGREE_LIST')).then(res => {
      if (res.result === '1') {
        commit(TYPES.ADD_HOSPITAL_DEGREE_DIC_LIST, res.data)
      }
    })
  },

  // 获取医生学位
  getDoctorDegreeDicList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    Vue.$http.get(Vue.getData('GET_DOCTOR_DEGREE_DIC_LIST')).then(res => {
      if (res.result === '1') {
        commit(TYPES.ADD_DOCTOR_DEGREE_DIC_LIST, res.data)
      }
    })
  },

  // 获取医生职称
  getDoctorTitleDicList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    Vue.$http.get(Vue.getData('GET_DOCTOR_TITLE_DIC_LIST')).then(res => {
      if (res.result === '1') {
        commit(TYPES.ADD_DOCTOR_TITLE_DIC_LIST, res.data)
      }
    })
  },

  // 获取积分状态列表
  getPointStatusList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    Vue.$http.get(Vue.getData('GET_ALL_POINT_STATUS_LIST')).then(res => {
      if (res.result === '1') {
        commit(TYPES.ADD_POINT_STATUS, res.data)
      }
    })
  },

  // 获取积分操作类型列表
  getHandleTypeList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    Vue.$http.get(Vue.getData('GET_ALL_POINT_HANDLE_TYPE_LIST')).then(res => {
      if (res.result === '1') {
        commit(TYPES.ADD_POINT_HANDLE_TYPE, res.data)
      }
    })
  },

  // 获取医院状态列表
  getHospitalStatusList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    Vue.$http.get(Vue.getData('GET_HOSPITAL_STATUS_LIST')).then(res => {
      if (res.result === '1') {
        commit(TYPES.ADD_HOSPITAL_STATUS_LIST, res.data)
      }
    })
  },

  // 获取提现状态字典信息
  getWithdrawStatusList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    Vue.$http.get(Vue.getData('GET_WITHDRAW_STATUS_DIC_LIST')).then(res => {
      if (res.result === '1') {
        commit(TYPES.ADD_WITHDRAW_STATUS_DIC_LIST, res.data)
      }
    })
  },

  // 获取医生状态字典信息
  getDoctorStatusList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    Vue.$http.get(Vue.getData('GET_DOCTOR_STATUS_DIC_LIST')).then(res => {
      if (res.result === '1') {
        commit(TYPES.ADD_DOCTOR_STATUS_LIST, res.data)
      }
    })
  },

  // 获取订单状态字典表
  getOrderStatusList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    Vue.$http.get(Vue.getData('GET_ORDER_STATUS_DIC_LIST')).then(res => {
      if (res.result === '1') {
        commit(TYPES.ADD_ORDER_STATUS_LIST, res.data)
      }
    })
  },

  // 获取订单病理类型字典表
  getOrderPathologyTypeList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    Vue.$http.get(Vue.getData('GET_ORDER_PATHOLOGY_TYPE_DIC_LIST')).then(res => {
      if (res.result === '1') {
        commit(TYPES.ADD_ORDER_PATHOLOGY_TYPE_LIST, res.data)
      }
    })
  },

  // 获取食道筛订单状态
  getEpsStatusList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    Vue.$http.get(Vue.getData('GET_ESOPHAGUS_STATUS_DIC_LIST')).then(res => {
      if (res.result === '1') {
        commit(TYPES.ADD_ESOPHAGUS_STATUS_DIC_LIST, res.data)
      }
    })
  },
  // 获取食道筛订单来源
  getEpsFromList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    Vue.$http.get(Vue.getData('GET_ESOPHAGUS_FROM_DIC_LIST')).then(res => {
      if (res.result === '1') {
        commit(TYPES.ADD_ESOPHAGUS_FROM_DIC_LIST, res.data)
      }
    })
  },
  // 获取食康一号的创建人列表
  getCreateUserList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_CREATE_USER_LIST'), qs.stringify(payload))
  },
  // 获取食康一号的来源的机器列表
  getSellMachineList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_SELL_MACHINE_LIST'), qs.stringify(payload))
  },
  // 获取虚拟配货的来源的机器列表
  getVirtualMacList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_VIR_MAC_LIST'), qs.stringify(payload))
  },
  // 获取虚拟订单列表
  getVirtualOrderList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_VIRTUAL_ORDER_LIST'), qs.stringify(payload))
  },
  // 删除虚拟订单
  deleteVirtualOrder ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('DELETE_VIRTUAL_ORDER'), qs.stringify(payload))
  },
  // 新增虚拟订单
  addVirtualOrderInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('ADD_VIRTUAL_ORDER_INFO'), qs.stringify(payload))
  },
  // 获取指定检测者的信息
  getTesterInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_TESTER_INFO'), qs.stringify(payload))
  },
  // 获取食道筛产品状态
  getEpsSNStatusList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    Vue.$http.get(Vue.getData('GET_EPS_SN_STATUS_DIC_LIST')).then(res => {
      if (res.result === '1') {
        commit(TYPES.ADD_EPS_SN_STATUS_DIC_LIST, res.data)
      }
    })
  },
  // 获取快递付款方式
  getExpressPayMethodDicList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    Vue.$http.get(Vue.getData('GET_EXPRESS_PAY_METHOD_DIC_LIST')).then(res => {
      if (res.result === '1') {
        commit(TYPES.ADD_EXPRESS_PAY_METHOD_DIC_LIST, res.data)
      }
    })
  },
  // 获取快递单位
  getExpressList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    Vue.$http.get(Vue.getData('GET_EXPRESS_DIC_LIST')).then(res => {
      if (res.result === '1') {
        commit(TYPES.ADD_EXPRESS_DIC_LIST, res.data)
      }
    })
  },
  // 获取收货方式
  getReceivingTypeList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    Vue.$http.get(Vue.getData('GET_RECEIVING_TYPE_DIC_LIST')).then(res => {
      if (res.result === '1') {
        commit(TYPES.ADD_RECEIVING_TYPE_DIC_LIST, res.data)
      }
    })
  },
  // 获取记录类型
  getRecordTypeDicList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    Vue.$http.get(Vue.getData('GET_RECORD_TYPE_DIC_LIST')).then(res => {
      if (res.result === '1') {
        commit(TYPES.ADD_RECORD_TYPE_DIC_LIST, res.data)
      }
    })
  },

  // 获取商品管理
  /**
   *  获取产品列表
   * @author JKD
   * @data 2019/2/20 11:26
   */
  async getEpsProductList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_EPS_PRODUCT_LIST'), qs.stringify(payload))
    if (result.result === '1') {
      console.log('!!!!!!!!!result:' + JSON.stringify(result))
      return {
        result: '1',
        data: result.data
      }
    }
  },

  // 根据产品Id获取商品详情
  async getEpsProductDetail ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_EPS_PRODUCT_DETAIL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 修改商品信息
  async updateEpsProductInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let res = await Vue.$http.post(Vue.getData('UPDATE_EPS_PRODUCT_INFO_URL'), qs.stringify(payload))
    if (res.result === '1') {
      return {
        result: '1'
      }
    }
  },

  // 新增商品信息
  async saveEpsProductInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('SAVE_EPS_PRODUCT_INFO_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1'
      }
    }
  },
  /* ********************************* 字典表 action edn ***************************** */
  /* ********************************* 柜员机管理 start ***************************** */
  // 查询柜员机的列表
  async getTellerMacList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_TELLER_MACHINE_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 新增柜员机的
  async addTellerMac ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('ADD_TELLER_MACHINE_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 删除柜员机
  async delTellerMac ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('DEL_TELLER_MACHINE_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 新增二维码
  async addWxMachine ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('ADD_MACHINE_QRCODE_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 修改柜员机的信息
  async editTellerMac ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('UPDATE_TELLER_MACHINE_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 修改柜员机的信息
  async getTellerMacById ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_TELLER_MACHINE_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 根据柜员机id 获取柜员机的销售详情
  async getTellerMacSalesDetails ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_TELLER_MAC_SALES_DETAILS_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 查询售出，回收，补货，取货数量
  async getStatisticsData ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_STATISTICS_DATA_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  /* ********************************* 柜员机管理 end ***************************** */

  /* ********************************* 代理商管理 start ***************************** */
  // 查询代理商的列表
  async getListAgent ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_LIST_AGENT_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 增加代理商
  async addAgent ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('ADD_AGENT_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },

  // 删除代理商
  async deleteAgentInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('DELETE_AGENT_INFO_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },

  // 修改代理商
  async updateAgent ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('UPDATE_AGENT_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },

  // 根据Id查询代理商信息
  async getAgentByAgencyId ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_AGENT_BY_AGENCY_ID_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },

  // 根据代理商绑定自助机的Id删除绑定的设备（逻辑删除）
  async deleteAgentBindingTellerMac ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('DELETE_AGENT_BINDING_TELLER_MAC_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },

  // 根据代理商绑定自助机的Id修改价格
  async editTellerMacPrice ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('EDIT_TELLER_MAC_PRICE_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },

  // 根据代理商id,查询代理商绑定的自助机列表
  async getAgentBindingTellerMacList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_AGENT_BINDING_TELLER_MAC_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 查询未被绑定的柜员机集合
  async getUnboundEquipmentList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_UNBOUND_EQUIPMENT_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 绑定多个设备
  async bindingMoreEquipment ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('BINDING_MORE_EQUIPMENT_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 绑定设备
  async bindingEquipment ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('BINDING_EQUIPMENT_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 根据手机号查询需要被绑定用户
  async getUnboundUserList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_UNBOUND_USER_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 代理商绑定用户
  async agentBindAdmin ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('AGENT_BIND_ADMIN_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    } else {
      return {
        result: '0',
        data: result.data
      }
    }
  },
  // 查询代理商已经绑定用户列表
  async getBoundingUserList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_BOUNDING_USER_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },

  // 删除代理商绑定用户
  async deleteAgentBoundingAdmin ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('DELETE_AGENT_BOUNDING_ADMIN_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  /* ********************************* 代理商管理 end ***************************** */

  /* ********************************* 营销中心 start ***************************** */

  // 查询推广员列表
  async getPromoterList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_PROMOTER_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },

  // 查询代理商列表，用于下拉查询
  async getAgentList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_AGENT_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      commit(TYPES.ADD_AGENT_LIST, result.data)
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 根据推广员id查询推广员信息
  async getPromoterByPromoterId ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_PROMOTER_BY_ID_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 根据推广员id,修改推广员信息
  async updatePromoterById ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('UPDATE_PROMOTER_BY_ID_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },

  // 根据推广员id删除推广员
  async deletePromoterById ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('DELETE_PROMOTER_BY_ID_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },

  /* ********************************* 营销中心 end ***************************** */

  /* ********************************* 优惠券管理 start ***************************** */
  // 查询优惠券列表
  async getCouponList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_COUPON_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取代理商的信息
  async getAgentInfoList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_AGENT_LIST_INFO_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取代理商的信息
  async addCouponInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('ADD_COUPON_INFO_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 修改优惠券信息
  async editCoupon ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('EDIT_COUPON_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 查询指定的优惠券信息
  async getCouponById ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_COUPON_BY_ID_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 查询订单使用指定优惠券信息
  async getCouponBindingOrderListList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_COUPON_BINDING_ORDER_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  /* ********************************* 优惠券管理 end ***************************** */

  /* ********************************* 统计报表 start ***************************** */
  // 查询订单报表相关数据
  async getReportData ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_REPORT_DATA_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 根据订单id,查询订单金额分成详情列表
  async getOrderAmountDetailList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_ORDER_AMOUNT_DETAIL_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  /* ********************************* 统计报表 end ***************************** */
  /* ********************************* 健康档案 start ***************************** */
  async getPatientRecordList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_PATIENT_RECORD_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 删除柜员机
  async delPatientRecord ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('DEL_PATIENT_RECORD_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 新增患者信息
  async addPatientInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('ADD_PATIENT_INFO_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取患者的信息
  async getPatientInfoById ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_PATIENT_INFO_BY_ID_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  async saveHealthRecords ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('SAVE_HEALTH_RECORDS_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  /* ********************************* 健康档案 end ***************************** */

  /* ********************************* 微信管理 start ***************************** */
  async getWeixinList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_WEIXIN_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取微信公众号菜单
  async getWechatMenuList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_WECHAT_MENU_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      commit(TYPES.ADD_WECHAT_MENU_URL, result.data)
    }
  },
  // 根据微信ID，菜单列，菜单行获取菜单信息
  async getWxMenuInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_WX_MENU_INFO_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 根据微信ID获取父级菜单
  async getWxParentMenu ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_WX_MENU_INFO_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 根据微信ID获取父级菜单
  async saveAndPublish ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('SAVE_AND_PUBLISH_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    } else {
      return {
        result: '0'
      }
    }
  },
  // 修改微信菜单
  async editWxMenuConf ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('EDIT_WX_MENU_CONF_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 删除微信菜单
  async deleteWxMenuConf ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('DELETE_WX_MENU_CONF_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 发布微信菜单
  async publishWechatMenu ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('PUBLISH_WECHAT_MENU_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取微信远端模板列表
  async getTemplateList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_TEMPLATE_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    } else {
      return {
        result: '0'
      }
    }
  },
  // 获取微信模板Id列表
  async getTemplateIdListByWxId ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_TEMPLATE_ID_LIST_BY_WX_ID_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 同步微信模板
  async saveTemplateInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('SAVE_TEMPLATE_INFO_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    } else {
      return {
        result: '0'
      }
    }
  },
  // 修改微信模板
  async editTemplateInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('EDIT_TEMPLATE_INFO_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    } else {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 从数据库中获取微信模板列表
  async getTemplateInfoList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_TEMPLATE_INFO_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 从数据库中删除微信模板
  async deleteTemplateInfoByTemplateNo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('DELETE_TEMPLATE_INFO_BY_TEMPLATE_NO_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    } else {
      return {
        result: '0'
      }
    }
  },
  // 获取模板参数列表
  async getTemplateParamList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_TEMPLATE_PARAM_LIST_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 修改模板参数
  async editTemplateParamColor ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('EDIT_TEMPLATE_PARAM_COLOR_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    } else {
      return {
        result: '0'
      }
    }
  },
  // 删除模板参数
  async deleteTemplateParam ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('DELETE_TEMPLATE_PARAM_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    } else {
      return {
        result: '0'
      }
    }
  },
  async saveWeiXin ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('SAVE_WEIXIN_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  async getWeixinById ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_WEIXINBYID_URL'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  /* ********************************* 微信管理 end ***************************** */
  /* ********************************* 统计员管理 start ***************************** */
  // 查询用户所绑定的设备名称
  async getTellerBindAdminList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_TELLER_BIND_ADMIN_LIST'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 根据用户ID获取已经绑定的设备信息
  async getTellerBindAdminByUserId ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_TELLER_BIND_ADMIN_BY_USER_ID'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 根据用户ID获取已经绑定的设备信息
  async saveTellerAdmin ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('SAVE_TELLER_ADMIN'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  /* ********************************* 统计员管理 end ***************************** */

  /* ********************************* 小程序用户角色 start ***************************** */
  // 获取小程序角色列表
  async getMpRoleList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_MP_ROLE_LIST_URL'), qs.stringify(payload))
  },
  // 根据id获取角色信息
  async getMpRoleById ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_MP_ROLE_BYID_URL'), qs.stringify(payload))
  },
  // 保存小程序角色
  async saveMpRole ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('SAVE_MP_ROLE_URL'), qs.stringify(payload))
  },
  // 根据id删除角色信息
  async delMpRoleById ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('DEL_MP_ROLE_BYID_URL'), qs.stringify(payload))
  },
  // 获取小程序用户列表
  async getMpUserList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_MP_USER_LIST_URL'), qs.stringify(payload))
  },
  // 根据id获取用户信息
  async getMpUserById ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_MP_USER_BYID_URL'), qs.stringify(payload))
  },
  // 保存小程序用户
  async saveMpUser ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('SAVE_MP_USER_URL'), qs.stringify(payload))
  },
  // 根据id删除用户信息
  async delMpUserById ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('DEL_MP_USER_BYID_URL'), qs.stringify(payload))
  },
  /* ********************************* 小程序用户角色 end ***************************** */

  // 查询送检单信息列表
  async getInspectionList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_INSPECTION_LIST_URL'), qs.stringify(payload))
  },
  // 查询检测信息列表
  async getInspectionParamList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_INSPECTION_PARAM_LIST_URL'), qs.stringify(payload))
  },
  // 删除检测信息
  async deleteInspectionParam ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('DELETE_INSPECTION_PARAM_URL'), qs.stringify(payload))
  },
  // 修改检测信息
  async editOrderNumById ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('EDIT_ORDER_NUM_BY_ID_URL'), qs.stringify(payload))
  },
  // 根据id获取送检单信息
  async getInspectionById ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_INSPECTION_BY_ID_URL'), qs.stringify(payload))
  },
  // 修改送检单信息
  async updateInspectionInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('UPDATE_INSPECTION_INFO_URL'), qs.stringify(payload))
  },
  /* ********************************* 发货管理 start ***************************** */
  async getDeliverListByCondition ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_DELIVER_LIST_BY_CONDITION'), qs.stringify(payload))
  },
  async getDeliveryInfoById ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_DELIVERY_INFO_BY_ID'), qs.stringify(payload))
  },
  async updateCourierUrl ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('UPDATE_COURIER_URL'), qs.stringify(payload))
  },
  async updateDeliveryInfoById ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('UPDATE_DELIVERY_INFO_BY_ID'), qs.stringify(payload))
  },
  /* ********************************* 发货管理 end ***************************** */
  async getCaseDataList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_CASE_DATA_LIST'), qs.stringify(payload))
  },
  async getSlideLayerByCaseId ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_SLIDELAYER_BY_CASE_ID'), qs.stringify(payload))
  },
  async getCropList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_CROP_LIST'), qs.stringify(payload))
  },
  /* ********************************* 卡包管理 stard ***************************** */
  // 添加主卡信息
  async addCard ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('ADD_CARD_URL'), qs.stringify(payload))
  },
  // 添加主卡信息
  async updateCard ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('UPDATE_CARD_URL'), qs.stringify(payload))
  },
  // 根据主卡id修改主卡信息
  async getCardByCardId ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_CARD_BY_CARD_ID_URL'), qs.stringify(payload))
  },
  // 查询主卡列表
  async getCardList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_CARD_LIST_URL'), qs.stringify(payload))
  },

  // 绑定主卡
  async saveCardInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('SAVE_CARD_INFO_URL'), qs.stringify(payload))
  },
  // 查询绑定主卡的信息列表
  async getCardInfoListByCardId ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_CARD_INFO_LIST_BY_CARD_ID_URL'), qs.stringify(payload))
  },
  // 查询绑定主卡的信息
  async getCardInfoByCardInfoId ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_CARD_INFO_BY_CARD_INFO_ID_URL'), qs.stringify(payload))
  },
  // 修改绑定主卡信息
  async updateCardInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('UPDATE_CARD_INFO_URL'), qs.stringify(payload))
  },
  // 批量添加主卡信息
  async bulkAddCard ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('BULK_ADD_CARD_URL'), qs.stringify(payload))
  },
  // 查询卡包出售配置列表
  async getCardOrderConfigList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_CARD_ORDER_CONFIG_LIST_URL'), qs.stringify(payload))
  },
  // 新增卡包出售配置
  async addCardOrderConfig ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('ADD_CARD_ORDER_CONFIG_URL'), qs.stringify(payload))
  },
  // 删除卡包出售配置
  async deleteCardOrderConfig ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('DELETE_CARD_ORDER_CONFIG_URL'), qs.stringify(payload))
  },
  // 修改卡包出售配置
  async updateCardOrderConfig ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('UPDATE_CARD_ORDER_CONFIG_URL'), qs.stringify(payload))
  },
  // 根据id获取卡包出售配置
  async getCardOrderConfigById ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_CARD_ORDER_CONFIG_BY_ID_URL'), qs.stringify(payload))
  },
  /* ********************************* 卡包管理 end ***************************** */

  /* ********************************* 分账管理 action start ***************************** */
  // 获取需要分账的订单信息
  async getProfitSharingOrderList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_PROFIT_SHARING_ORDER_LIST'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取需要分账的详细信息
  async getProfitSharingOrderDetailList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_PROFIT_SHARING_ORDERD_ETAIL_LIST'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取需要分账接收方的详细信息
  async getProfitSharingOrderUserList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_PROFIT_SHARING_ORDER_USER_LIST'), qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 查询分账结果
  async getProfitSharingResults ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_PROFIT_SHARING_RESULTS'), qs.stringify(payload))
  },
  // 请求分账
  async getProfitSharingOrders ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_PROFIT_SHARING_ORDERS'), qs.stringify(payload))
  },
  // 解冻剩余资金
  async getProfitSharingUnfreezeOrders ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_PROFIT_SHARING_UNFREEZE_ORDERS'), qs.stringify(payload))
  },
  // 查询利润分享的用户列表
  async getProfitSharingUserList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_PROFIT_SHARING_USER_LIST'), qs.stringify(payload))
  },
  // 删除利润分享的用户
  async deleteProfitSharingUser ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('DELETE_PROFIT_SHARING_USER'), qs.stringify(payload))
  },
  // 获取分账接收方类型
  async getRecipientTypeList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_RECIPIENT_TYPE_LIST'), qs.stringify(payload))
  },
  // 获取与分账方的关系类型
  async getRelationTypeList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_RELATION_TYPE_LIST'), qs.stringify(payload))
  },
  // 获取微信列表
  async getWxInfoList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_WX_INFO_LIST'), qs.stringify(payload))
  },
  // 添加分账用户
  async saveProfitSharingUser ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('SAVE_PROFIT_SHARING_USER'), qs.stringify(payload))
  },
  // 根据昵称和手机号查询微信用户信息
  async getOpenIdByNickNameOrPhone ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_OPEN_ID_BY_NICK_NAME_OR_PHONE'), qs.stringify(payload))
  },
  // 根据openId和wxId获取分账用户信息
  async isExistProfitSharingUser ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('IS_EXIST_PROFIT_SHARING_USER'), qs.stringify(payload))
  },
  /* ********************************* 分账管理 action end ***************************** */
  // 医院登录报告系统查询报告
  async getEpsSnCaseReportByUserId ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_EPSSNCASEREPORT_BY_USERID'), qs.stringify(payload))
  },
  // 库存管理
  async getBoxList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_BOX_LIST'), qs.stringify(payload))
  },
  async delBoxById ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('DEL_BOX_BY_ID'), qs.stringify(payload))
  },
  async getProductsList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_PRODUCT_LIST'), qs.stringify(payload))
  },
  async delProductIdById ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('DEL_PRODUCT_BY_ID'), qs.stringify(payload))
  },
  async getShipmentList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('GET_SHIPMENT_LIST'), qs.stringify(payload))
  },
  async delShipmentById ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post(Vue.getData('DEL_SHIPMENT_BY_ID'), qs.stringify(payload))
  },
  async getJianCeEpsSnByInfo ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post('eps/getJianCeEpsSnByInfo', qs.stringify(payload))
  },
  async getPMSBaoxianCase ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post('synchro/getPMSBaoxianCase', qs.stringify(payload))
  },
  /* ********************************* 分账管理 action state ***************************** */
  async getServiceExpertList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post('serviceExperts/getServiceExpertList', qs.stringify(payload))
  },
  async getServiceExpertById ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post('serviceExperts/getServiceExpertById', qs.stringify(payload))
  },
  async saveServiceExpert ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post('serviceExperts/saveServiceExpert', qs.stringify(payload))
  },
  async delServiceExpertById ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post('serviceExperts/delServiceExpertById', qs.stringify(payload))
  },
  async getServicePackageList ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post('servicePackages/getServicePackageList', qs.stringify(payload))
  },
  async getServicePackageById ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post('servicePackages/getServicePackageById', qs.stringify(payload))
  },
  async saveServicePackage ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post('servicePackages/saveServicePackage', qs.stringify(payload))
  },
  async delServicePackageById ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post('servicePackages/delServicePackageById', qs.stringify(payload))
  },
  async getServiceOrder ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post('serviceOrder/getServiceOrder', qs.stringify(payload))
  },
  async createServiceOrder ({commit}, payload) {
    let Vue = payload.vue
    delete payload.vue
    return Vue.$http.post('serviceOrder/createServiceOrder', qs.stringify(payload))
  },
  /* ********************************* 分账管理 action end ***************************** */
  /* ************************************ 制片管理 start ****************************** */
  // 设备管理相关请求
  async createDevice ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('CREATE_DEVICE_URL'), qs.stringify(payload))
    return result
  },
  async updateDevice ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('UPDATE_DEVICE_URL'), qs.stringify(payload))
    return result
  },
  async deleteDevice ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('DELETE_DEVICE_URL'), qs.stringify(payload))
    return result
  },
  async getDeviceList ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_DEVICE_LIST_URL'), qs.stringify(payload))
    return result
  },
  async getDeviceById ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_DEVICE_BY_ID_URL'), qs.stringify(payload))
    return result
  },

  // 库存管理相关请求
  async createInventory ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('CREATE_INVENTORY_URL'), qs.stringify(payload))
    return result
  },
  async updateInventory ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('UPDATE_INVENTORY_URL'), qs.stringify(payload))
    return result
  },
  async deleteInventory ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('DELETE_INVENTORY_URL'), qs.stringify(payload))
    return result
  },
  async getInventoryList ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_INVENTORY_LIST_URL'), qs.stringify(payload))
    return result
  },
  async getInventoryById ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_INVENTORY_BY_ID_URL'), qs.stringify(payload))
    return result
  },

  // 产品类型管理相关请求
  async createProductType ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('CREATE_PRODUCT_TYPE_URL'), qs.stringify(payload))
    return result
  },
  async updateProductType ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('UPDATE_PRODUCT_TYPE_URL'), qs.stringify(payload))
    return result
  },
  async deleteProductType ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('DELETE_PRODUCT_TYPE_URL'), qs.stringify(payload))
    return result
  },
  async getProductTypesList ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_PRODUCT_TYPES_LIST_URL'), qs.stringify(payload))
    return result
  },
  async getProductTypeById ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_PRODUCT_TYPE_BY_ID_URL'), qs.stringify(payload))
    return result
  },

  // 二维码管理相关请求
  async createQrCode ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('CREATE_QR_CODE_URL'), qs.stringify(payload))
    return result
  },
  async updateQrCode ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('UPDATE_QR_CODE_URL'), qs.stringify(payload))
    return result
  },
  async deleteQrCode ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('DELETE_QR_CODE_URL'), qs.stringify(payload))
    return result
  },
  async getQrCodesList ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_QR_CODES_LIST_URL'), qs.stringify(payload))
    return result
  },
  async getQrCodeById ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_QR_CODE_BY_ID_URL'), qs.stringify(payload))
    return result
  },

  // 试剂管理相关请求
  async createReagent ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('CREATE_REAGENT_URL'), qs.stringify(payload))
    return result
  },
  async updateReagent ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('UPDATE_REAGENT_URL'), qs.stringify(payload))
    return result
  },
  async deleteReagent ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('DELETE_REAGENT_URL'), qs.stringify(payload))
    return result
  },
  async getReagentsList ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_REAGENTS_LIST_URL'), qs.stringify(payload))
    return result
  },
  async getReagentById ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_REAGENT_BY_ID_URL'), qs.stringify(payload))
    return result
  },
  async fetchAvailableDevices ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_AVAILABLE_DEVICES_URL'), qs.stringify(payload))
    return result
  },
  // 历史记录管理相关请求
  async getHistoryRecordsList ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_HISTORY_RECORDS_LIST_URL'), qs.stringify(payload))
    return result
  },
  /* ************************************ 制片管理 end ****************************** */

  /* ************************************ 申请发货管理 start ****************************** */

  // 获取采购代理商列表
  async getPurchaseAgentList ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_PURCHASE_AGENT_LIST_URL'), qs.stringify(payload))
    return result
  },

  // 删除采购代理商
  async deletePurchaseAgent ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('DELETE_PURCHASE_AGENT_URL'), qs.stringify(payload))
    return result
  },

  async getPurchaseAgentById ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post(Vue.getData('GET_PURCHASE_AGENT_BY_ID_URL'), qs.stringify(payload))
    return result
  },

  // 新增获取修改申请发货代理商
  async savePurchaseAgent ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post('/purchase/agent/saveOrUpdate', payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return result
  },
  // 获取申请发货产品list用于下拉框
  async getPurchaseProductListForSelect ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post('/purchase/product/getPurchaseProductListForSelect', payload)
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取申请发货代理商list用于下拉框
  async getPurchaseAgentListForSelect ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post('/purchase/agent/getPurchaseAgentListForSelect', qs.stringify(payload))
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 申请发货管理分页列表
  async getShipmentRequestList ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post('/purchase/shipmentRequest/selectPage', qs.stringify(payload))
    return result
  },
  // 修改或新增发货申请
  async saveOrUpdateShipmentRequest ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post('/purchase/shipmentRequest/saveOrUpdate', qs.stringify(payload))
    return result
  },
  // 删除申请发货
  async deleteShipmentRequest ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post('/purchase/shipmentRequest/removeById', qs.stringify(payload))
    return result
  },
  // 获取型号-规格数据用于选择框
  async getPurchaseModelListForSelect ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.get('/dic/dicPurchaseSpecificationModel', payload)
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  // 获取产品单位数据用于选择框
  async getPurchaseUnitListForSelect ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.get('/dic/dicPurchaseUnit', payload)
    if (result.result === '1') {
      return {
        result: '1',
        data: result.data
      }
    }
  },
  async getPurchaseProductList ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post('/purchase/product/selectPage', qs.stringify(payload))
    return result
  },
  // 修改或新增发货申请产品
  async saveOrUpdatePurchaseProduct ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post('/purchase/product/saveOrUpdate', qs.stringify(payload))
    return result
  },
  // 删除申请发货产品
  async deletePurchaseProduct ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = await Vue.$http.post('/purchase/product/removeById', qs.stringify(payload))
    return result
  },

  /* ************************************ 申请发货管理 end ****************************** */

  // 获取pms系统中的医院列表
  getPmsHospitalList ({ commit }, payload) {
    let Vue = payload.vue
    delete payload.vue
    let result = Vue.$http.post('/statisticsExporter/getPmsHospitalList', qs.stringify(payload))
    return result
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/actions.js